import { trigger, transition, animate, style, state } from '@angular/animations';

export const GrowWidth = trigger('GrowWidth', [
    state('open', style({ width: '*', opacity: 1 })),
    state('closed', style({ width: '0px', opacity: 0, display: 'none' })),

    transition('open => closed', [animate('0.4s cubic-bezier(0.5, 0, 0, 1)')]),
    transition('closed => open', [animate('0.4s cubic-bezier(0.5, 0, 0, 1)')]),
]);
